module.exports = __webpack_public_path__ + "img/nonimpact.de87ddce.svg";